import React from 'react'
import styles from './ActionButton.scss'
import PropTypes from 'prop-types'

const DisabledReason = ({children}) => (
  <div className={styles.disabledReason}>
    <div className={styles.content}>
      {children}
    </div>
  </div>
)

export const ActionButton = ({children, as, disabled, primary, success, dark, onClick, className = [], icon, disabledReason = null, ...rest}) => {
  const ActionButton = as
  const ButtonColor = primary ? 'blue' : (success ? 'green': (dark ? 'gray' : 'default'))
  const ButtonDisabled = disabled ? styles[`${ButtonColor}Disabled`] : styles[ButtonColor]

  return (
    <ActionButton className={`${ButtonDisabled} ${className}`} onClick={disabled ? undefined : onClick} disabled={disabled} {...rest}>
      {icon && <span className={styles.icon}>{icon}</span>}{children}
      {disabled && !!disabledReason && <DisabledReason>{disabledReason}</DisabledReason>}
    </ActionButton>
  )
}

ActionButton.propTypes = {
  disabled: PropTypes.bool,
  primary: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  icon: PropTypes.object
}

ActionButton.defaultProps = {
  as: 'div',
  className: ''
}

export default ActionButton
